import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { navigationItems } from '../config/navigation';
import AdminLayout from '../layouts/AdminLayout';
import AccessDeniedPage from '../pages/AccessDeniedPage';
import AdminModulePage from '../pages/AdminModulePage';
import NotFoundPage from '../pages/NotFoundPage';
import ComponentsPage from '../pages/ComponentsPage';
import DashboardPage from '../pages/DashboardPage';
import ElectoralStructurePage from '../pages/ElectoralStructurePage';
import LoginPage from '../pages/LoginPage';
import ChangePasswordPage from '../pages/ChangePasswordPage';
import VoterPortalPage from '../pages/VoterPortalPage';
import UsersPage from '../pages/UsersPage';
import VotersPage from '../pages/VotersPage';
import VoterDetailPage from '../pages/VoterDetailPage';
import DuplicatesPage from '../pages/DuplicatesPage';
import CallSheetsPage from '../pages/CallSheetsPage';
import CallSheetDetailPage from '../pages/CallSheetDetailPage';
import DriversPage from '../pages/DriversPage';
import VehiclesPage from '../pages/VehiclesPage';
import VehicleDetailPage from '../pages/VehicleDetailPage';
import ReportsPage from '../pages/ReportsPage';
import AuditPage from '../pages/AuditPage';
import FinancePage from '../pages/FinancePage';
import FleetReviewPage from '../pages/FleetReviewPage';
import ElectionDayPage from '../pages/ElectionDayPage';
import { ACTIONS, RESOURCES, ROLES, createPermission } from '../config/accessControl';
import ProtectedRoute from './ProtectedRoute';
import { ROUTE_PATHS } from './routePaths';
import { useAuth } from '../context/AuthContext';

function AppRoutes() {
  return (
    <BrowserRouter
      future={{ v7_relativeSplatPath: true, v7_startTransition: true }}
    >
      <Routes>
        <Route path={ROUTE_PATHS.LOGIN} element={<LoginPage />} />
        <Route element={<ProtectedRoute />}>
          <Route path={ROUTE_PATHS.CHANGE_PASSWORD} element={<ChangePasswordPage />} />
          <Route path={ROUTE_PATHS.HOME} element={<RoleHomeRedirect />} />
          <Route
            element={<ProtectedRoute roles={[ROLES.VOTANTE]} />}
          >
            <Route path={ROUTE_PATHS.VOTER_PROFILE} element={<VoterPortalPage />} />
          </Route>
          <Route path={ROUTE_PATHS.ACCESS_DENIED} element={<AccessDeniedPage />} />
          <Route element={<ProtectedRoute roles={[
            ROLES.ADMINISTRADOR,
            ROLES.ADMINISTRADOR_GENERAL,
            ROLES.COORDINADOR,
            ROLES.PUNTERO,
            ROLES.VOTANTE,
          ]} />}>
            <Route element={<AdminLayout />}>
            <Route path={ROUTE_PATHS.COMPONENTS} element={<ComponentsPage />} />
            {navigationItems.map((item) => (
              <Route
                key={item.path}
                element={
                  <ProtectedRoute
                    roles={item.roles}
                    permission={item.permission}
                  />
                }
              >
                <Route
                  path={item.path}
                  element={
                    item.path === ROUTE_PATHS.DASHBOARD
                      ? <DashboardPage />
                      : item.path === ROUTE_PATHS.ELECTORAL_STRUCTURE
                        ? <ElectoralStructurePage />
                        : item.path === ROUTE_PATHS.VOTERS
                          ? <VotersPage />
                        : item.path === ROUTE_PATHS.USERS
                          ? <UsersPage />
                        : item.path === ROUTE_PATHS.DUPLICATES
                          ? <DuplicatesPage />
                        : item.path === ROUTE_PATHS.CALL_SHEETS
                          ? <CallSheetsPage />
                        : item.path === ROUTE_PATHS.DRIVERS
                          ? <DriversPage />
                        : item.path === '/moviles'
                          ? <VehiclesPage />
                        : item.path === '/reportes'
                          ? <ReportsPage />
                        : item.path === '/auditoria'
                          ? <AuditPage />
                        : item.path === '/financiero'
                          ? <FinancePage />
                        : item.path === '/revision-flota'
                          ? <FleetReviewPage />
                        : item.path === '/dia-d'
                          ? <ElectionDayPage />
                      : <AdminModulePage />
                  }
                />
              </Route>
            ))}
            <Route
              element={
                <ProtectedRoute
                  roles={[
                    ROLES.ADMINISTRADOR,
                    ROLES.ADMINISTRADOR_GENERAL,
                    ROLES.COORDINADOR,
                    ROLES.PUNTERO,
                  ]}
                  permission={createPermission(RESOURCES.VOTERS, ACTIONS.VIEW)}
                />
              }
            >
              <Route
                path={ROUTE_PATHS.VOTER_DETAIL}
                element={<VoterDetailPage />}
              />
            </Route>
            <Route
              element={
                <ProtectedRoute
                  roles={[
                    ROLES.ADMINISTRADOR,
                    ROLES.ADMINISTRADOR_GENERAL,
                    ROLES.COORDINADOR,
                    ROLES.PUNTERO,
                  ]}
                  permission={createPermission(RESOURCES.VEHICLES, ACTIONS.VIEW)}
                />
              }
            >
              <Route
                path={ROUTE_PATHS.VEHICLE_DETAIL}
                element={<VehicleDetailPage />}
              />
            </Route>
            <Route
              element={
                <ProtectedRoute
                  roles={[
                    ROLES.ADMINISTRADOR_GENERAL,
                  ]}
                  permission={createPermission(RESOURCES.CALL_SHEETS, ACTIONS.VIEW)}
                />
              }
            >
              <Route
                path={ROUTE_PATHS.CALL_SHEET_DETAIL}
                element={<CallSheetDetailPage />}
              />
            </Route>
            </Route>
          </Route>
          <Route path={ROUTE_PATHS.NOT_FOUND} element={<NotFoundPage />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

function RoleHomeRedirect() {
  const { user } = useAuth();
  return (
    <Navigate
      to={user.role === ROLES.VOTANTE ? ROUTE_PATHS.VOTER_PROFILE : ROUTE_PATHS.DASHBOARD}
      replace
    />
  );
}

export default AppRoutes;
